import { User } from '@/models/User';

export class Stylist extends User {
  protected $name: string = 'Stylist';
  protected $endpoint: string = '/users';

  protected filters: object = {
    role: 'stylist',
  };
}
